export default __webpack_public_path__ + "static/media/Women_Sizing_Guide.e9d3d120.png";